import * as React from "react";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Typography,
	Container,
	Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { faqData } from "./headerConstant";
import { faqData } from "../../fragments/header/headerConstant";

export default function Faq() {
	const [expanded, setExpanded] = React.useState(false);

	const handleChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};

	return (
		<Container maxWidth="md" sx={{ py: 4, px: 2 }}>
			{/* FAQ Header */}
			<Box textAlign="center" mb={4}>
				<Typography variant="h4" component="h2" gutterBottom>
					Frequently Asked Questions
				</Typography>
				<Typography variant="subtitle1" color="text.secondary">
					Find answers to common questions about our courier services
				</Typography>
			</Box>

			{/* FAQ Items */}
			{faqData.map((item) => (
				<Accordion
					key={item.id}
					expanded={expanded === item.id}
					onChange={handleChange(item.id)}
					sx={{
						mb: 2,
						borderRadius: 1,
						boxShadow: 1,
						"&:before": {
							display: "none", // Remove default arrow line
						},
						transition: "all 0.3s ease",
						"&.Mui-expanded": {
							boxShadow: 3,
						},
					}}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls={`${item.id}-content`}
						id={`${item.id}-header`}
						sx={{
							bgcolor: "background.paper",
							"&:hover": {
								bgcolor: "action.hover",
							},
						}}>
						<Typography
							variant="subtitle1"
							sx={{ fontWeight: 600, flexShrink: 0 }}>
							{/* {item.title} */}
						</Typography>
						{item.subtitle && (
							<Typography
								variant="body2"
								sx={{ ml: 2, color: "text.secondary" }}>
								{item.subtitle}
							</Typography>
						)}
					</AccordionSummary>
					<AccordionDetails sx={{ px: 4, py: 2 }}>
						<Typography variant="body2" lineHeight={1.5}>
							{item.content}
						</Typography>
					</AccordionDetails>
				</Accordion>
			))}
		</Container>
	);
}
